import { isNil } from 'lodash/fp';
import { useCallback, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageContext } from './Context';

const useLanguageContext = () => {
    const context = useContext(LanguageContext);

    // some router they might not have language
    if (!context) {
        return null;
    }

    return context;
};

export const useLanguage = () => {
    const languageContext = useLanguageContext();
    const { i18n } = useTranslation();

    const updateLanguage = useCallback(
        (newLanguageId: string) => {
            const newLanguage = languageContext?.languageOptions.find(language => language.value === newLanguageId);
            if (isNil(newLanguage)) {
                throw new Error('Language not found in the options');
            }
            languageContext?.setCurrentLanguageId(newLanguage.value);
        },
        [i18n, languageContext]
    );

    return useMemo(
        () => ({
            updateLanguage,
            languageOptions: languageContext?.languageOptions,
            currentLanguageId: languageContext?.currentLanguageId,
        }),
        [languageContext?.currentLanguageId, languageContext?.languageOptions, updateLanguage]
    );
};
